import { render, staticRenderFns } from "./StatsPushNotifications.vue?vue&type=template&id=4a5f4c94&"
import script from "./StatsPushNotifications.vue?vue&type=script&lang=js&"
export * from "./StatsPushNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports